import { apiDataSource } from "@/io/datasource/ApiDatasource";
import { BaseApiDatasourceSpec } from "@/io/datasource/BaseApiDatasource.ts";
import { SupportInfo, supportInfoSchema } from "@/models/SupportInfoModel.ts";

export class ConfigRepository {
  constructor(private readonly datasource: BaseApiDatasourceSpec = apiDataSource) {}

  getSupportInfo = (): Promise<SupportInfo> => {
    return this.datasource.get("/config/", supportInfoSchema);
  };
}
